var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGift = function SvgGift(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8589 6.49878H4.141C3.27293 6.49878 2.56921 7.2025 2.56921 8.07057V11.2141C2.56921 12.0822 3.27293 12.7859 4.141 12.7859H19.8589C20.727 12.7859 21.4306 12.0822 21.4306 11.2141V8.07057C21.4306 7.2025 20.727 6.49878 19.8589 6.49878Z",
    stroke: "currentColor",
    strokeWidth: 1.995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8588 12.7859V19.8589C19.8588 20.2758 19.6932 20.6756 19.3985 20.9703C19.1038 21.265 18.7039 21.4307 18.2871 21.4307H5.71278C5.29591 21.4307 4.89612 21.265 4.60135 20.9703C4.30659 20.6756 4.14099 20.2758 4.14099 19.8589V12.7859",
    stroke: "currentColor",
    strokeWidth: 1.995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.49878V21.4307",
    stroke: "currentColor",
    strokeWidth: 1.995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7153 2.56934L11.9999 6.4988L7.28455 2.56934",
    stroke: "currentColor",
    strokeWidth: 1.995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGift);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "gift.2eb98e42c17191cd2c8a2192f692a3a1.svg";